'use client';

import { FC, useEffect, useState } from 'react';
import { useFormStatus } from 'react-dom';

import { getOr } from 'src/utils/getOr';

import { ControlInputGroup } from './ControlInput/ControlInputGroup';
import { InputFormProps } from './Input.type';

/**
 * Checkbox input field expected to be used within a React Form
 */

type Props = Prettify<Omit<InputFormProps<typeof ControlInputGroup>, 'type'>>;

export const InputCheckboxForm: FC<Props> = ({ id, name, disabled, formState, onValueCheckboxChange, ...props }) => {
  const inputId = id ?? name;
  const error = getOr(formState, `errors.${name}[0]`, null);
  const { pending } = useFormStatus();
  const [value, setValue] = useState<string[]>(props.defaultValue ? props.defaultValue.split(',') : []);

  useEffect(() => {
    onValueCheckboxChange?.(value);
  }, [value]);

  return (
    <ControlInputGroup
      {...props}
      id={inputId}
      name={name}
      error={error}
      disabled={disabled || pending}
      value={value}
      onChange={setValue}
      type="checkbox"
    />
  );
};
